import React, { useEffect, useRef, useState } from "react";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { TertiaryButton } from "@components/v2/buttons";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { type OverviewSavedView } from "@features/overview-v2/types";

import { SavedViewsMenuLoadingRow } from "./saved-views-menu-loading-row";

interface UpdatedSavedViewProps {
  readonly savedView: OverviewSavedView;
  readonly onClose: () => void;
}

export const UpdateSavedViews = ({
  savedView,
  onClose,
}: UpdatedSavedViewProps) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const inputRef = useRef<HTMLInputElement>(null);
  const [localValue, setLocalValue] = useState(savedView.name);
  const {
    updateSavedViewName,
    saveViewsSavingState: { isSavingName },
  } = useOverviewContext();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="text-xs w-full h-full flex items-center bg-inherit z-1">
      <SavedViewsMenuLoadingRow
        isLoading={isSavingName === savedView.id}
        text="Updating..."
      >
        <div className="border-b border-cosmic flex items-center w-full">
          <input
            ref={inputRef}
            className="flex-1 text-sm h-full bg-inherit font-normal w-full"
            type="text"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
          />
          <TertiaryButton
            className="hover:bg-transparent"
            onClick={async () => {
              prettyLogEventPage({
                domain: "Saved Views",
                action: "onClick",
                additionalActionInfo: "Update Saved View Name",
                data: {
                  pageContext: { savedViewId: savedView.id },
                },
              });
              await updateSavedViewName(savedView.id, localValue, {
                onError: () => "There was an error updating the view's name.",
                onSuccess: () => onClose(),
              });
            }}
          >
            SAVE
          </TertiaryButton>
        </div>
      </SavedViewsMenuLoadingRow>
    </div>
  );
};
